export default [
  {
    path: '/real-estate-developments-settings/installment-integration-tables',
    name: 'InstallmentIntegrationTablesList',
    component: () => import('src/pages/real-estate-developments-settings/installment-integration-tables/InstallmentIntegrationTablesList.vue')
  },
  {
    path: 'real-estate-developments-settings/installment-integration-tables/new',
    name: 'InstallmentIntegrationTablesCreate',
    component: () => import('src/pages/real-estate-developments-settings/installment-integration-tables/InstallmentIntegrationTablesForm.vue')
  },
  {
    path: '/real-estate-developments-settings/installment-integration-tables/:id',
    component: () => import('pages/real-estate-developments-settings/installment-integration-tables/_layouts/InstallmentIntegrationTablesSingleLayout.vue'),
    children: [
      {
        path: 'edit',
        name: 'InstallmentIntegrationTablesEdit',
        meta: { slug: 'edit' },
        component: () => import('src/pages/real-estate-developments-settings/installment-integration-tables/InstallmentIntegrationTablesForm.vue')
      },
      {
        path: 'real-estate-developments',
        name: 'InstallmentIntegrationTablesRealEstateDevelopmentsList',
        meta: { slug: 'real-estate-developments' },
        component: () => import('src/pages/real-estate-developments-settings/installment-integration-tables/tabs/IntallmentIntegrationTablesRealEstateDevelopmentsList.vue')
      },
      {
        path: 'history',
        name: 'InstallmentIntegrationTablesHistoryList',
        meta: { slug: 'history' },
        component: () => import('src/pages/real-estate-developments-settings/installment-integration-tables/tabs/InstallmentIntegrationTablesHistoryList.vue')
      }
    ]
  }
]
